import request from '@/utils/request'

export function fetchAdminVisit(query) {
  return request({
    url: '/admin/visit',
    method: 'get',
    params: query
  })
}

export function uploadAdminImage(file) {
  const fileData = new FormData()
  fileData.append('img', file)
  return request({
    url: '/upload/admin',
    method: 'post',
    data: fileData
  })
}

export function transferAdminMedia2Url(mediaId) {
  return request({
    url: '/upload/admin/media_id_to_url',
    method: 'post',
    data: {
      media_id: mediaId
    }
  })
}

export function fetchAdminDownloadList(query) {
  return request({
    url: '/admin/download/list',
    method: 'get',
    params: query
  })
}

export function fetchAdminTagList() {
  return request({
    url: '/admin/tag/list',
    method: 'get'
  })
}

export function updateUserCoin(item) {
  return request({
    url: '/admin/user/coin',
    method: 'put',
    data: item
  })
}

export function fetchAdminUserInfo(query) {
  return request({
    url: '/admin/user',
    method: 'get',
    params: query
  })
}

export function fetchAdminVisitData(query) {
  return request({
    url: '/admin/visit/data',
    method: 'get',
    params: query
  })
}

export function fetchAdminClientData() {
  return request({
    url: '/admin/user/stat',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/admin/index.js